window.mobilecheck = function() {
  var check = false;
  (function(a,b){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

global.initBlock = function(selector) {
	try {
        if (typeof selector == "string") {
            selector = $('#'+selector);
        }

		// on met en service les nouveaux contrôles
		if (BEHAV) BEHAV.apply(selector);

		//run all scripts now contained in the target div element
		//runScripts($(selector));
	}
	catch(scriptError) {
		msg('error', '<strong>Erreur Javascript : </strong>&nbsp;&nbsp;&nbsp;&nbsp;'+scriptError.message);
		abort = true;
		if (console) {
			console.error(scriptError.stack);
		}
		// throw scriptError.stack;
	}
};

global.unloadBlock = function(selector) {
	try {
		// on retire les contrôles
		if (typeof selector == 'string') {
			BEHAV.apply(selector, 'unload');
		}
	}
	catch(scriptError) {
		msg('error', '<strong>Erreur Javascript : </strong>&nbsp;&nbsp;&nbsp;&nbsp;'+scriptError.message);
		abort = true;
		if (console) {
			console.error(scriptError.stack);
		}
		// throw scriptError.stack;
	}
};

global.getWindow = function(element) {
	if (element) {
        if (element.constructor.name == 'Object') {
            return element;
        }
		return $.window.getWindow($(element).parents('.window_panel').attr('id'));
	}
	else {
		return $.window.getLastWindow();
	}
}

global.closeWindow = function(element, quiet, data) {
    if (getWindow(element)) {
        getWindow(element).options.returnData = data;
        getWindow(element).close(quiet);
    }
}

global.reopenWindow = function(form, url, title) {
    var oldWindows = getWindow(form);
    closeWindow(form);
    var options = oldWindows.options;
    options.url = url;
    options.title = title;
    $.window(options);
}

global.scrollToSelector = function(selector) {
	$.scrollTo(selector, 60 );
}

global.clearZone = function(target, animation) {
	unloadBlock(target);
	target = $(target);
	if (animation) {
		target.fadedSlideUp(500, 'swing', function(){$(this).html(''); $(this).show()});
	}
	else {
		target.html('')
	}
}

global.clear_id = function(div) {
	clearZone('#'+div);
}

global.setVisibility = function(div, state) {
	if (state) {
		document.getElementById(div).style.display = "block";
	}
	else {
		document.getElementById(div).style.display = "none";
	}
}

global.runScripts = function(e) {
	$(e).find("script").each(function(i) {
		eval($(this).text());
	});
}

global.enableButtonIfnotEmpty = function(input) {
	if (input.value) {
		$('#editeur_boutons #btn_ajout').attr('disabled', false);
		$('#editeur_boutons #btn_edit').attr('disabled', false);
	}
	else {
		$('#editeur_boutons #btn_ajout').attr('disabled', true);
		$('#editeur_boutons #btn_edit').attr('disabled', true);
	}

	if (input.value == $('#nom_defaux').val()) {
		$('#editeur_boutons #btn_ajout').attr('disabled', true);
	}
}

global.selectTableInfoLine = function(currentEl) {
	$(currentEl).parents('table').find('tr').removeClass('selected');
	$(currentEl).parents('tr').addClass('selected');
}


global.highlightElement = function(element, state) {
	if (state) {
		$(element).addClass('highlightElement');
	}
	else {
		$(element).removeClass('highlightElement');
	}
}



global.check_password = function(var_name, valeur) {
	if (document.getElementById(var_name+'_f1').value == document.getElementById(var_name+'_f2').value && document.getElementById(var_name+'_f1').value != "") {
		document.getElementById(var_name).value = document.getElementById(var_name+'_f1').value;
		document.getElementById(var_name+'_check').innerHTML = '<img src="icons/sets/'+skin+'/ico/status-ok.png" height="16" alt="ok" />';
	}
	else if (document.getElementById(var_name+'_f1').value == document.getElementById(var_name+'_f2').value && document.getElementById(var_name+'_f1').value == "" && document.getElementById(var_name).value != "") {
		document.getElementById(var_name).value = "'.$value.'";
		document.getElementById(var_name+'_check').innerHTML = '<img src="img/blank.gif" height="16" alt="" />';
	}
	else if (document.getElementById(var_name+'_f1').value == document.getElementById(var_name+'_f2').value && document.getElementById(var_name+'_f1').value == "") {
		document.getElementById(var_name).value = "";
		document.getElementById(var_name+'_check').innerHTML = '<img src="icons/sets/'+skin+'/ico/status-warning.png" height="16" alt="erreur" />';
	}
	else {
		document.getElementById(var_name).value = "";
		document.getElementById(var_name+'_check').innerHTML = '<img src="icons/sets/'+skin+'/ico/shape-cross.png" height="16"  alt="erreur" />';
	}
}

global.initPatch404Img = function(replacementImg) {
	$("img").each(function(){
      var image = $(this);
      if(image.context.naturalWidth == 0 || image.readyState == 'uninitialized'){
			if ($(this).width() <= 128) {
				$(this).attr('data-src', $(this).attr('src'));
				$(this).attr('src', 'img/blank.gif');
				$(this).css('background', 'url(\''+replacementImg+'\') no-repeat center center');
				$(this).css('background-size', 'auto '+$(this).width()+'px');
			}
			else {
				$(this).attr('data-src', $(this).attr('src'));
				$(this).attr('src', 'img/blank.gif');
				$(this).css('background', 'url(\''+replacementImg+'\') no-repeat center center');
			}
      }
	});
}

$.fn.fadedSlideUp = function (speed, easing, callback) {
    this.animate({height: "hide", paddingTop: "hide", marginTop: "hide", paddingBottom: "hide", marginBottom: "hide", opacity: "hide"}, speed, easing, callback);
};
$.fn.fadedSlideDown = function (speed, easing, callback) {
    this.animate({height: "show", paddingTop: "show", marginTop: "show", paddingBottom: "show", marginBottom: "show", opacity: "show"}, speed, easing, callback);
};


global.include = function(filename, filetype){
	if (filetype=="js"){ //if filename is a external JavaScript file
		var fileref=document.createElement('script');
		fileref.setAttribute("type","text/javascript");
		fileref.setAttribute("src", filename);
	}
	else if (filetype=="css"){ //if filename is an external CSS file
		var fileref=document.createElement("link");
		fileref.setAttribute("rel", "stylesheet");
		fileref.setAttribute("type", "text/css");
		fileref.setAttribute("href", filename);
	}
	if (typeof fileref!="undefined")
		document.getElementsByTagName("head")[0].appendChild(fileref);
}

global.isDefined = function(value) {
	if (typeof(value) == "undefined") {
		return false;
	}
	return true;
}

global.clone = function(obj) {
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}

	var temp = obj.constructor(); // give temp the original obj's constructor
	for (var key in obj) {
		temp[key] = clone(obj[key]);
	}

	return temp;
}

$.fn.isAfter = function(sel){
	return this.prevAll(sel).length !== 0;
}
$.fn.isBefore= function(sel){
	return this.nextAll(sel).length !== 0;
}

global.clipboardCopy = function(text, mute) {
    var input = document.body.appendChild(document.createElement("textarea"));
    $(input).css('position', 'fixed');
    input.value = text;
    input.focus();
    input.select();
    document.execCommand('copy');
    input.parentNode.removeChild(input);

    if (!mute) msg('info', 'Lien copié', 1000);
}

global.mergeToObject = function(src, dest) {
    for (var key in src) {
        if (src.hasOwnProperty(key)) {
            if (src[key] !== null && typeof src[key] == 'object' && typeof dest[key] == 'object') {
                if (!dest[key]) dest[key] = {}
                mergeToObject(src[key], dest[key]);
            }
            else {
                dest[key] = src[key];
            }
        }
    }
}

global.flattenAssociativeProps = function(obj) {
	const result = { ...obj };

	for (const [key, value] of Object.entries(obj)) {
	if (
		value &&
		typeof value === 'object' &&
		!Array.isArray(value)
	) {
		for (const [subKey, subValue] of Object.entries(value)) {
		if (!(subKey in result)) {
			result[subKey] = subValue;
		}
		}
	}
	}

	return result;
}

global.in_array = function(needle, haystack) {
	return Array.isArray(haystack) && haystack.includes(needle);
}

global.arrayRemove = function(array, val) {
    var i = array.indexOf(val);
    return i>-1 ? array.splice(i, 1) : [];
};

global.log = function(element) {
    console.log(element);
}

window.mouseX = 0;
window.mouseY = 0;
global.getCursorXY = function(e) {
    mouseX = (window.Event) ? e.pageX : event.clientX + (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft);
    mouseY = (window.Event) ? e.pageY : event.clientY + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop);
}
document.onmousemove = global.getCursorXY;
